import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import ActivityReportContainer from '../general/ActivityReportContainer'
import PurchaseOrdersReportContainer from '../general/PurchaseOrdersReportContainer'
import OpenItemsContainer from '../general/OpenItemsContainer'
import ToolsReportContainer from '../general/ToolsReportContainer'
import ScheduleReportContainer from '../general/ScheduleReportContainer'
import JobMinutesReportContainer from '../general/JobMinutesReportContainer'

// Financial Reports
import AIAsReportContainer from '../financial/AIAsReportContainer'
import MaintenanceFinancialsReportContainer from '../financial/MaintenanceFinancialsReportContainer'
import PaymentRequestReportContainer from '../financial/PaymentRequestReportContainer'
import InvoicesReportContainer from '../financial/InvoicesReportContainer'
import ActiveJobContractsReportContainer from '../financial/ActiveJobContractsReportContainer'

//Leads Reports
import LeadsReportContainer from '../leads/LeadsReportContainer'
import ProposalsSentContainer from '../leads/ProposalsSentContainer'
import ContractsSentContainer from '../leads/ContractsSentContainer'

//Jobs Reports
import JobsReportContainer from '../jobs/JobsReportContainer'
import DrawingsReportContainer from '../jobs/DrawingsReportContainer'
import ConfirmedShipmentDatesContainer from '../jobs/ConfirmedShipmentDatesContainer'
import TransmittalsReportContainer from '../jobs/TransmittalsReportContainer'
import RFIsReportContainer from '../jobs/RFIsReportContainer'
import SiteWorkSchedulesReportContainer from '../jobs/SiteWorkSchedulesReportContainer'
import ManufacturingScheduleContainer from '../jobs/ManufacturingScheduleContainer'
import DrawingSchedulesReportContainer from '../jobs/DrawingSchedulesReportContainer'
import ChangeOrdersReportContainer from '../jobs/ChangeOrdersReportContainer'
import FinancialSchedulesReportContainer from '../jobs/FinancialSchedulesReportContainer'

// Maintenance/DOB Reports
import StopCallsReportContainer from '../maintenance_dob/StopCallsReportContainer'
import ViolationsReportContainer from '../maintenance_dob/ViolationsReportContainer'
import TargetedMonthlyVisitsReportContainer from '../maintenance_dob/TargetedMonthlyVisitsReportContainer'
import ApplicationSchedulesReportContainer from '../maintenance_dob/ApplicationSchedulesReportContainer'
import TicketsReportContainer from '../maintenance_dob/TicketsReportContainer'
import MaintenanceSchedulesReportContainer from '../maintenance_dob/MaintenanceSchedulesReportContainer'
import PrivateRoute from '../../PrivateRoute'
import roles from '../../../constants/Roles'

class ReportRoutes extends Component {
  render() {
    return (
      <Switch>
        <Route path="/reports/general/activity-report" render={() => <ActivityReportContainer />} />
        <Route path="/reports/general/open-items-report" render={() => <OpenItemsContainer />} />
        <Route
          path="/reports/general/purchase-orders-report"
          render={() => <PurchaseOrdersReportContainer />}
        />
        <Route path="/reports/general/tools-report" render={() => <ToolsReportContainer />} />
        <Route path="/reports/general/schedule-report" render={() => <ScheduleReportContainer />} />
        <Route
          path="/reports/general/job-minutes-report"
          render={() => <JobMinutesReportContainer />}
        />
        <PrivateRoute
          allowedRoles={[roles.ADMIN, roles.CONTROLLER_1, roles.CONTROLLER_2]}
          path="/reports/financial/aias-report"
          component={AIAsReportContainer}
          renderAdminApp={false}
        />
        <PrivateRoute
          allowedRoles={[roles.ADMIN, roles.CONTROLLER_1, roles.CONTROLLER_2]}
          path="/reports/financial/payment-request-report"
          component={PaymentRequestReportContainer}
          renderAdminApp={false}
        />
        <PrivateRoute
          allowedRoles={[roles.ADMIN, roles.CONTROLLER_1, roles.CONTROLLER_2]}
          path="/reports/financial/invoices-report"
          component={InvoicesReportContainer}
          renderAdminApp={false}
        />
        <PrivateRoute
          allowedRoles={[roles.ADMIN, roles.CONTROLLER_1, roles.CONTROLLER_2]}
          path="/reports/financial/maintenance-financials-report"
          component={MaintenanceFinancialsReportContainer}
          renderAdminApp={false}
        />
        <PrivateRoute
          allowedRoles={[roles.ADMIN, roles.CONTROLLER_1, roles.CONTROLLER_2]}
          path="/reports/financial/active-job-contracts-report"
          component={ActiveJobContractsReportContainer}
          renderAdminApp={false}
        />

        {/* Leads */}
        <Route path="/reports/leads/leads" render={() => <LeadsReportContainer />} />

        <Route path="/reports/leads/proposals-sent" render={() => <ProposalsSentContainer />} />

        <Route path="/reports/leads/contracts-sent" render={() => <ContractsSentContainer />} />

        {/* Jobs */}
        <Route path="/reports/jobs/jobs" render={() => <JobsReportContainer />} />

        <Route path="/reports/jobs/drawings" render={() => <DrawingsReportContainer />} />

        <Route
          path="/reports/jobs/confirmed-shipment-dates"
          render={() => <ConfirmedShipmentDatesContainer />}
        />

        <Route path="/reports/jobs/transmittals" render={() => <TransmittalsReportContainer />} />

        <Route path="/reports/jobs/rfis" render={() => <RFIsReportContainer />} />

        <Route
          path="/reports/jobs/site-work-schedules"
          render={() => <SiteWorkSchedulesReportContainer />}
        />

        <Route
          path="/reports/jobs/manufacturing-schedule"
          render={() => <ManufacturingScheduleContainer />}
        />

        <Route
          path="/reports/jobs/drawing-schedules"
          render={() => <DrawingSchedulesReportContainer />}
        />

        <Route path="/reports/jobs/change-orders" render={() => <ChangeOrdersReportContainer />} />

        <Route
          path="/reports/jobs/financial-schedules"
          render={() => <FinancialSchedulesReportContainer />}
        />

        {/* Maintenance/DOB Reports */}
        <Route
          path="/reports/maintenance-dob/stop-calls-report"
          render={() => <StopCallsReportContainer />}
        />

        <Route
          path="/reports/maintenance-dob/violations-report"
          render={() => <ViolationsReportContainer />}
        />

        <Route
          path="/reports/maintenance-dob/targeted-monthly-visits-report"
          render={() => <TargetedMonthlyVisitsReportContainer />}
        />

        <Route
          path="/reports/maintenance-dob/application-schedules-report"
          render={() => <ApplicationSchedulesReportContainer />}
        />

        <Route
          path="/reports/maintenance-dob/tickets-report"
          render={() => <TicketsReportContainer />}
        />

        <Route
          path="/reports/maintenance-dob/maintenance-schedules-report"
          render={() => <MaintenanceSchedulesReportContainer />}
        />

        <Route path="/reports" render={() => <ActivityReportContainer />} />
      </Switch>
    )
  }
}

export default ReportRoutes



// WEBPACK FOOTER //
// ./src/containers/reports/routes/routes.js